import { of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { utilTime } from "../../../utils/utilTime";
import { actionCoopInfoSetProjectAccessTime, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopInfoSetProjectAccessTime = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionCoopInfo.Received ||
            action.type === TypeActionCoopInfo.MemberResponse;
    }), filter(function (action) {
        return action.member != undefined;
    }), switchMap(function (action) {
        var state = state$.value;
        var playerId = state.playerInfo.playerId;
        var ownMemberInfo = action.member.find(function (member) {
            return member.playerId.equals(playerId);
        });
        if (ownMemberInfo && ownMemberInfo.secondsUntilCoopProjectAccess) {
            var coopProjectRemainingAccessTime = utilTime.remainingTimeToTimestamp(ownMemberInfo.secondsUntilCoopProjectAccess);
            return of(actionCoopInfoSetProjectAccessTime(coopProjectRemainingAccessTime));
        }
        return of(actionCoopInfoSetProjectAccessTime());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopInfoSetProjectAccessTime.ts
// module id = 1805
// module chunks = 3